import ContractDetailsTab from "./ContractDetailsTab";

export default ContractDetailsTab;